module.exports = __webpack_public_path__ + "img/split.c23fbf0f.png";